(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-store/assets/javascripts/endpoints/favorites-api.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-store/assets/javascripts/endpoints/favorites-api.js');
"use strict";


const {
  jupiterFetch
} = svs.core;
const {
  fetchBaseQuery,
  createApi
} = RTKQ;
const favoritesApi = createApi({
  reducerPath: 'favoritesApi',
  baseQuery: fetchBaseQuery({
    baseUrl: jupiterFetch.url(),
    fetchFn: jupiterFetch.fetch,
    prepareHeaders: headers => {
      headers.set('Content-Type', 'application/json');
      return headers;
    }
  }),
  tagTypes: ['Favorites'],
  endpoints: builder => ({
    getFavorites: builder.query({
      query: () => '/casino/1/favorites',
      transformResponse: response => response.favorites || [],
      providesTags: ['Favorites']
    }),
    updateFavorites: builder.mutation({
      query: favorites => ({
        url: "/casino/1/favorites?favorites=".concat(encodeURIComponent(favorites.join(';'))),
        method: 'PUT'
      }),
      invalidatesTags: ['Favorites']
    })
  })
});
setGlobal('svs.components.casino_react.casinoStore.endpoints.favoritesApi', favoritesApi);

 })(window);